import { Box, styled, Typography, useMediaQuery, useTheme } from '@mui/material';
import { FC } from 'react';

interface IProps {
	label: string;
	children: React.ReactNode;
	alignment?: 'center' | 'right' | 'left';
	size?: 'md' | 'lg';
}

const Label = styled(Typography)(({ theme }) => ({
	fontSize: '1.2rem',
	width: '60%',
	fontFamily: theme.typography.fontFamily,
	paddingRight: '0.2rem',
	color: theme.palette.text.primary,
}));

const ValueText = styled(Typography)(({ theme }) => ({
	width: '40%',
	fontSize: '1.2rem',
	fontFamily: theme.typography.fontFamily,
}));

const DisplayField: FC<IProps> = ({ label, children, alignment, size }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	return (
		<Box mb={2} display={{ display: isMobile ? 'block' : 'flex' }} width='100%'>
			{isMobile ? (
				<>
					<Box sx={{ fontWeight: '500', width: '100%' }}>{label.length > 0 ? label : null}</Box>
					<Box fontSize={size === 'lg' ? '20px' : 'unset'} sx={{ textAlign: alignment, width: '100%' }}>
						{children}
					</Box>
				</>
			) : (
				<>
					<Label sx={{ fontWeight: '500' }}>{label.length > 0 ? `${label}:` : null}</Label>
					<ValueText sx={{ textAlign: alignment }}>{children}</ValueText>
				</>
			)}
		</Box>
	);
};

export default DisplayField;
